import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import {
    DxColumn, DxColumnChooser,
    DxDataGrid, DxFilterPanel, DxFilterRow,
    DxGrouping,
    DxGroupPanel, DxHeaderFilter,
    DxPager,
    DxPaging,
    DxScrolling, DxSearchPanel,
    DxSorting, DxStateStoring,
    DxGroupItem, DxSummary,
    DxSortByGroupSummaryInfo
} from "devextreme-vue/data-grid";

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== '';
}

export const dataSourceMixin = {
    components: {
        DxDataGrid,
        DxColumn,
        DxPager,
        DxPaging,
        DxSorting,
        DxGroupPanel,
        DxGrouping,
        DxScrolling,
        DxColumnChooser,
        DxStateStoring,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxFilterPanel,
        DxGroupItem,
        DxSummary,
        DxSortByGroupSummaryInfo,
    },
    data() {
        return {
            loading: true,
            showError: false,
            errorMessage: 'Error while loading weather forecast.',
            dataSource: null,
            allElementCount: null,
        }
    },
    methods: {
        getAllElementCount(endpoint) {
            axios.get(`${endpoint}/total`).then((response) => {
                // @ts-ignore
                this.allElementCount = response.data;
            })
        },
        getDataSource(endpoint) {
            // @ts-ignore
            this.dataSource = new CustomStore({
                key: 'id',
                load: (loadOptions) => {
                    let params = '?';
                    [
                        'skip',
                        'take',
                        'requireTotalCount',
                        'requireGroupCount',
                        'sort',
                        'filter',
                        'totalSummary',
                        'group',
                        'groupSummary'
                    ].forEach(function(i) {
                        if(i in loadOptions && isNotEmpty(loadOptions[i]))
                        { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
                    });
                    params = params.slice(0, -1);
                    return axios.get(`${endpoint}${params}`).then((data) => {
                        return {
                            data: data.data.data,
                            totalCount: data.data.totalCount,
                            summary: data.data.summary,
                            groupCount: data.data.groupCount
                        };
                    });
                },
            });
        },
    },
}
